import { useEffect, useRef } from 'react';
import gsap from 'gsap';

const Cursor = () => {
  const dotRef = useRef(null);

  useEffect(() => {
    const dot = dotRef.current;
    if (!dot || window.matchMedia('(max-width: 1023px)').matches) return;

    const xTo = gsap.quickTo(dot, 'x', { duration: 0.45, ease: 'power3.out' });
    const yTo = gsap.quickTo(dot, 'y', { duration: 0.45, ease: 'power3.out' });

    const onMove = (e) => {
      xTo(e.clientX);
      yTo(e.clientY);
      const t = e.target;
      dot.classList.remove('cursor-text', 'cursor-image', 'cursor-button');
      if (t.closest('button, a, [data-cursor="button"]')) dot.classList.add('cursor-button');
      else if (t.closest('img, [data-cursor="image"]')) dot.classList.add('cursor-image');
      else if (t.closest('h1, h2, h3, p, blockquote, [data-cursor="text"]')) dot.classList.add('cursor-text');
    };

    window.addEventListener('mousemove', onMove, { passive: true });
    return () => window.removeEventListener('mousemove', onMove);
  }, []);

  return <div ref={dotRef} className="cursor-dot" style={{ filter: 'blur(0.5px)' }} />;
};

export default Cursor;
